export const nativeEvent = ([event, message]: [string, string]) => {
  window.postMessage(`${event} ${message}`, window.origin);
};
